<template>
  <v-content>
    <div class="vis-page-content">
      <VisContainer
        :orgCode="orgCode"
        :tripId="parseInt(tripId)"
        :openInNewVisible="false"
        prefsKeyPrefix="AdminPage"
      />
    </div>
  </v-content>

  <!-- <v-tabs
                centered
                v-model="currentTab"
                background-color="transparent"
              >
                <v-tab href="#1">Geral</v-tab>
                <v-tab href="#2">JSON</v-tab>
                <v-tab href="#3">Rawdata</v-tab>
                <v-tab href="#4">Parsed Data</v-tab>
              </v-tabs> -->

  <!-- <v-tabs-items
            class="fill-height fill-width"
            touchless
            v-model="currentTab"
          >
            <v-tab-item value="1" class="fill-height">
              <div class="d-flex fill-height">
                <div
                  class="elevation-2 scroll-y"
                  :style="{ width: sideW + 'px', zIndex: 1 }"
                >
                  <VisSidebar :value="data" @changeVarsClick="changeVars" />
                </div>

                <TripVis
                  :height="h"
                  :width="w - sideW"
                  :tripData="data"
                  :lapseIndex="lapseIndex"
                />
              </div>
            </v-tab-item>
            <v-tab-item value="2">
              <VisJson :value="data" @forceClosed="reload"/>
            </v-tab-item>
            <v-tab-item value="3">
              <VisRawdata :value="data" />
            </v-tab-item>
            <v-tab-item value="4">
              <VisParsedData :value="data" />
            </v-tab-item>
          </v-tabs-items> -->
</template>

<script>
import VisContainer from './VisContainer.vue'

// import _ from 'lodash'
// import FetchVisData from './FetchVisData'
// import { savePref, getPref } from 'oderon-vue/Prefs'

// const _key = 'oderonTripVisVariables'

export default {
  components: {
    VisContainer
    // TripVis: require('./TripVis').default,
    // VisVarsDialog: require('./VisVarsDialog').default,
    // VisSidebar: require('./VisSidebar').default,
    // VisJson: require('./VisJson').default,
    // VisRawdata: require('./VisRawdata').default,
    // VisParsedData: require('./VisParsedData').default
  },
  data() {
    return {
      // currentTab: '1',
      // isLoading: true,
      // data: null,
      // errReason: null,
      // currentVars: getPref(_key, [
      //   'rpm',
      //   'speed',
      //   'brake',
      //   'brakeWithSpeed',
      //   'gps',
      //   'dg1'
      // ])
    }
  },
  props: {
    orgCode: { type: String },
    tripId: {}
  },
  computed: {
    // detailsVisible() {
    //   return true
    // },
    // lapseIndex() {
    //   let l = this.$route.query.lapseIndex
    //   if (l == null || l.trim() == '') return null
    //   return +l
    // },
    // firstTrip() {
    //   return _.get(this.data, 'trips[0]', {})
    // },
    // driver() {
    //   return this.firstTrip.driver || {}
    // },
    // vehicle() {
    //   return this.firstTrip.vehicle || {}
    // },
    // maxW() {
    //   return document.documentElement.clientWidth
    // },
    maxH() {
      return document.documentElement.clientHeight
    },
    isSm() {
      return this.$vuetify.breakpoint.smAndDown
    },
    // sideW() {
    //   return this.isSm ? 0 : 300
    // },
    h() {
      let topBarH = this.isSm ? 56 : 64 + 64 - 8
      return this.maxH - topBarH
      // if ( this.isSm ) return this.maxH
      // else return this.maxH - 120
    }
    // w() {
    //   return this.maxW
    //   // if ( this.isSm ) return this.maxW
    //   // else return this.maxW - 120
    // }
  }
  // watch: {
  //   orgCode() {
  //     this.reload()
  //   },
  //   tripId() {
  //     this.reload()
  //   }
  // },
  // mounted() {
  //   this.reload()
  // },
  // methods: {
  //   reload() {
  //     this.data = null
  //     this.errReason = null
  //     // this.navBy = navBy
  //     this.$loading(() => this.fetchData())
  //     return this.$open()
  //   },
  //   async fetchData() {
  //     try {
  //       this.data = await FetchVisData({
  //         orgId: this.orgCode,
  //         tripId: this.tripId,
  //         vars: this.currentVars
  //       })
  //     } catch (err) {
  //       this.errReason = err.reason
  //     }
  //   },
  //   async changeVars() {
  //     let curVars = this.currentVars,
  //       dialog = this.$refs.varsDialog,
  //       newVars = await dialog.open(curVars, this.varRegistry)

  //     if (newVars != null) {
  //       this.currentVars = newVars
  //       savePref(_key, newVars)
  //       this.$loading(() => this.fetchData())
  //     }
  //   }
  // }
}
</script>

<style lang="sass">
.vis-page-content
  width: 100%
  height: calc(100vh - 64px)
  overflow: hidden

  .cap-cont .big-content
    font-size: 16px !important
    font-weight: normal
</style>
